import { FormContent, GenericData, FormValue } from "../types";

export type Action<A> =
  | { type: "INITIALIZE_DATA"; payload: A }
  | {
      type: "UPDATE_CONTENT";
      payload: GenericData | FormValue;
    }
  | {
      type: "RESET_DATA";
    };

export const formReducer = <A extends FormContent>(
  state: A,
  action: Action<A>
) => {
  switch (action.type) {
    case "INITIALIZE_DATA":
      return action.payload as A;
    case "UPDATE_CONTENT":
      const updatedValue = action.payload;
      if (!Array.isArray(state.values)) {
        const key = Object.keys(action.payload)[0];
        const value = Object.values(action.payload)[0];
        if (!state.hasOwnProperty(key)) {
          return { ...state, [key]: value };
        }
        return { ...state, [key]: value };
      } else {
        state.values = [...state.values];

        if (
          !state.values?.find(
            (a: FormValue) => a.fieldAlias === updatedValue.fieldAlias
          )
        ) {
          const { fieldAlias, value } = updatedValue;
          return { ...state, values: [...state.values, { fieldAlias, value }] };
        }
        return {
          ...state,
          values: state.values?.map((a) =>
            a.fieldAlias === updatedValue.fieldAlias ? updatedValue : a
          ),
        };
      }
    case "RESET_DATA":
      if (!Array.isArray(state.values)) {
        return {};
      } else {
        const formId = state.formId;
        return { formId, values: [] } as unknown as A;
      }
    default:
      return state;
  }
};
